import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Radio, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import numeral from "numeral";

const { Item: ItemForm } = Form;
const { Column } = Table;
const ButtonGroup = Button.Group;

export default class PedidoItemGradeForm extends Component {
  state = {
    editando: false,
    produtoGradeSelecionado: [],
    listaGrades: [],
    gradeTipoSelect: [],
    gradeTamanhoSelect: [],

    registro: {
      vig_item: 0,
      vig_seq: 0,
      vig_tipo_grade: 0,
      vig_tam_grade: 0,
      vig_qtde: 0,
      vig_obs: '',
      gtp_descricao: '',
      gtam_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.produtoGradeSelecionado !== propsAnterior.produtoGradeSelecionado) {

      this.state.listaGrades = [];
      this.state.editando = this.props.produtoGradeSelecionado.editando;
      this.state.produtoGradeSelecionado = this.props.produtoGradeSelecionado ? this.props.produtoGradeSelecionado : [];

      this.buscaGradesTipos()
      this.montaGrade(this.props.listaGrades);
    }
  }

  componentDidMount() {

  }





  onOK = () => {
    let listaRegistros = [];
    const listaGeral = this.props.listaGrades;
    const listaAtual = this.state.listaGrades;

    for (var x in listaGeral) {
      if (listaGeral[x].vig_item !== this.props.produtoGradeSelecionado.prod_idf) {
        listaRegistros.push({
          vig_item: listaGeral[x].vig_item,
          vig_seq: listaGeral[x].vig_seq,
          vig_tipo_grade: listaGeral[x].vig_tipo_grade,
          vig_tam_grade: listaGeral[x].vig_tam_grade,
          vig_qtde: listaGeral[x].vig_qtde,
          vig_obs: listaGeral[x].vig_obs,
          gtp_descricao: listaGeral[x].gtp_descricao,
          gtam_descricao: listaGeral[x].gtam_descricao,
        });
      }
    }

    for (var x in listaAtual) {
      if (listaAtual[x].vig_item === this.props.produtoGradeSelecionado.prod_idf) {
        listaRegistros.push({
          vig_item: listaAtual[x].vig_item,
          vig_seq: listaAtual[x].vig_seq,
          vig_tipo_grade: listaAtual[x].vig_tipo_grade,
          vig_tam_grade: listaAtual[x].vig_tam_grade,
          vig_qtde: listaAtual[x].vig_qtde,
          vig_obs: listaAtual[x].vig_obs,
          gtp_descricao: listaAtual[x].gtp_descricao,
          gtam_descricao: listaAtual[x].gtam_descricao,
        });
      }
    }

    this.props.onSalvarGradeClick(listaRegistros, this.props.produtoGradeSelecionado);
  };


  onGravar = () => {
    if ((!this.state.registro.vig_tipo_grade) || (this.state.registro.vig_tipo_grade.key === '0') || (this.state.registro.vig_tipo_grade.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Grade', });
      return;
    }
    if ((!this.state.registro.vig_tam_grade) || (this.state.registro.vig_tam_grade.key === '0') || (this.state.registro.vig_tam_grade.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tamanho', });
      return;
    }
    if (!this.state.registro.vig_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a quantidade', });
      return;
    }
    if ((this.state.registro.vig_qtde) && (parseFloat(this.state.registro.vig_qtde) < 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Quantidade menor que zero', });
      return;
    }

    this.state.listaGrades.push({
      vig_item: this.props.produtoGradeSelecionado.prod_idf,
      vig_seq: this.props.produtoGradeSelecionado.vi_seq,
      vig_tipo_grade: parseInt(this.state.registro.vig_tipo_grade.key),
      vig_tam_grade: parseInt(this.state.registro.vig_tam_grade.key),
      vig_qtde: parseFloat(this.state.registro.vig_qtde),
      gtp_descricao: this.state.registro.vig_tipo_grade.label,
      gtam_descricao: this.state.registro.vig_tam_grade.label,
    });

    this.setState({
      vig_tipo_grade: 0,
      vig_tam_grade: 0,
      vig_qtde: 0,
    });
  };

  onExcluirClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir esta Grade?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaGrades = [...this.state.listaGrades];
        const index = listaGrades.findIndex(registro => registro.vig_tipo_grade === reg.vig_tipo_grade && registro.vig_tam_grade === reg.vig_tam_grade);
        listaGrades.splice(index, 1);
        this.setState({
          listaGrades,
        });
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <Tooltip title="Excluir" placement="top">
        <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirClick(registro)} icon="delete" />
      </Tooltip>
    );
  };


  montaGrade = (lista) => {
    // console.log('montaGrade', lista)

    let listaRegistros = [];
    for (var x in lista) {
      if (lista[x].vig_item === this.props.produtoGradeSelecionado.prod_idf) {
        listaRegistros.push({
          vig_idf: lista[x].vig_idf,
          vig_item: lista[x].vig_item,
          vig_seq: lista[x].vig_seq,
          vig_tipo_grade: lista[x].vig_tipo_grade,
          vig_tam_grade: lista[x].vig_tam_grade,
          vig_qtde: lista[x].vig_qtde,
          vig_obs: lista[x].vig_obs,
          gtp_descricao: lista[x].gtp_descricao,
          gtam_descricao: lista[x].gtam_descricao,
        });
      }
    };

    // console.log('montaGrade', listaRegistros)

    this.setState({
      listaGrades: listaRegistros,
    });
  }

  buscaGradesTipos = (value) => {
    this.setState({ gradeTipoSelect: [] })
    const { vig_tipo_grade } = this.state.registro;
    axios.get('/gradesTipo/lista', {
    }).then(response => {
      const { data } = response;
      const gradeTipoSelect = data.map(regList => {
        return {
          key: regList.gtp_idf,
          label: regList.gtp_descricao
        }
      });

      let grade = vig_tipo_grade;
      if (!vig_tipo_grade) {
        grade = gradeTipoSelect[0].key;
      }

      this.setState({
        gradeTipoSelect,
        vig_tipo_grade: grade,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }

  buscaGradesTamanhos = (value) => {
    if (value) {
      this.setState({ gradeTamanhoSelect: [] })
      const { vig_tam_grade } = this.state.registro;
      axios.get('/gradesTamanho/lista', {
        params: {
          grade: value.key,
        }
      }).then(response => {
        const { data } = response;
        const gradeTamanhoSelect = data.map(regList => {
          return {
            key: regList.gtam_idf,
            label: regList.gtam_descricao
          }
        });

        let grade = vig_tam_grade;
        if (!vig_tam_grade) {
          grade = gradeTamanhoSelect[0].key;
        }

        this.setState({
          gradeTamanhoSelect,
          vig_tam_grade: grade,
        })

      }).catch(error => {
        console.error(error.response);
      })
    }
  }



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeGrade = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value }, this.buscaGradesTamanhos(value));
  };

  onChangeQtde = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  renderValor = (vig_qtde, registro) => {
    return (
      <span> {numeral(parseFloat(vig_qtde)).format('0,000.00')} </span>
    );
  };




  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalGradeClick, visivel } = this.props;
    const { editando, listaGrades, gradeTipoSelect, gradeTamanhoSelect } = this.state;
    const { vig_tipo_grade, vig_tam_grade, vig_qtde } = this.state.registro;

    // console.log('PedidoItemGradeForm.this.state: ', this.state);

    return (
      <Modal
        title="Grade"
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalGradeClick}
        footer={null}
        width={"40%"}
        style={{ top: 40 }}
      >
        <div>

          <div>
            <Row>
              {editando ? (
                <Row>
                  <Col xs={24} sm={8} style={{ marginTop: 10, paddingRight: 15 }}>
                    <span>Grade</span>
                    <InputForm
                      type="select"
                      id="vig_tipo_grade"
                      ref="vig_tipo_grade"
                      value={vig_tipo_grade}
                      placeholder="Selecione"
                      onChange={this.onChangeGrade}
                      data={gradeTipoSelect}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                      showSearch
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: 10, paddingRight: 15 }}>
                    <span>Tamanho</span>
                    <InputForm
                      type="select"
                      id="vig_tam_grade"
                      ref="vig_tam_grade"
                      value={vig_tam_grade}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={gradeTamanhoSelect}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                      showSearch
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: 10 }}>
                    <span>Quantidade</span>
                    <InputForm
                      type="number"
                      id="vig_qtde"
                      ref="vig_qtde"
                      value={vig_qtde}
                      onChange={this.onChangeQtde}
                    />
                  </Col>
                  <Col xs={24} sm={24} style={{ marginBottom: 60, marginTop: -20 }}>
                    <Button
                      htmlType="button"
                      onClick={this.onGravar}
                      icon="plus"
                      className="botoesModalForm2x"
                    > Adicionar
                    </Button>
                  </Col>
                </Row>
              ) : null}

              <Row>
                <Col xs={24}>
                  <Table
                    dataSource={listaGrades}
                    pagination={false}
                    rowKey={(listaGrades => listaGrades.vig_tipo_grade + '_' + listaGrades.vig_tam_grade)}
                  >
                    <Column
                      key="gtp_descricao"
                      dataIndex="gtp_descricao"
                      title="Grade"
                      width={"25%"}
                      align="center"
                      className="listaCadastro"
                    />
                    <Column
                      key="gtam_descricao"
                      dataIndex="gtam_descricao"
                      title="Tamanho"
                      width={"25%"}
                      align="center"
                      className="listaCadastro"
                    />
                    <Column
                      key="vig_qtde"
                      dataIndex="vig_qtde"
                      title="Qtde"
                      render={this.renderValor}
                      width={"25%"}
                      align="right"
                      className="listaCadastro"
                    />
                    <Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutos}
                      width={"25%"}
                      align="right"
                      className="listaCadastro"
                    />
                  </Table>
                </Col>
              </Row>
            </Row>
          </div>





          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                {editando ? (
                  <Button
                    htmlType="button"
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar
                  </Button>
                ) : null}
                <Button
                  htmlType="button"
                  onClick={onFecharModalGradeClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PedidoItemGradeForm.js